import React, { Component } from 'react';
import { Grid, GridColumn as Column, GridToolbar } from '@progress/kendo-react-grid';
import '@progress/kendo-theme-default/dist/all.css';
import { filterBy, orderBy } from '@progress/kendo-data-query';
import { ExcelExport, ExcelExportColumn } from '@progress/kendo-react-excel-export';
import { connect } from 'react-redux';
import Modal from 'react-modal';
import { toastr } from '../../../../../Redux/Actions/CommonActions';
import { Switch } from '@progress/kendo-react-inputs';
import { Alert } from 'reactstrap';
import AdminHeader from '../../../AdminHeader/AdminHeader';
import cellWithEditing from './CellWithEditing';
import Search from '../../../Search';
import IsLoading from '../../../../Shared/Loading/IsLoading';
import '../ManageUsers/ManageUser.scss';
import axios from 'axios';
import { ROOT_API_URL } from '../../../../../api-config';
import { auth, userService } from '../../../../../services';
import {
  resetView
} from '../../../../../Redux/Actions/Admin/ManagePurchaseAndRenewalsActions';
import './ManagePurchaseAndRenewals.scss';
import PurchaseContainer from './PurchaseContainer/PurchaseContainer';
import PurchaseAndRenewalDetailsForm from './PurchaseAndRenewalDetailsForm';
import PurchaseAndRenewalsLoader from './PurchaseAndRenewalsLoader';
import ReceiptPDF from '../../../../Shared/ReceiptPDF';
import GridDateTimeFormatter from '../../../GridDateTimeFormatter';
import GridDateFormatter from '../../../GridDateFormatter';
import DialogContainer from './Dialogs/DialogContainer';


const FileDownload = require('js-file-download');

class CustomCell extends React.Component {
  render() {
    const value = this.props.dataItem[this.props.field];
    console.log("value in transaction grid", value);
    return (
      <td> {
        (value === null) ? '' : "$" + this.props.dataItem[this.props.field].toFixed(2).toString()}
      </td>
    );
  }
}

class ManagePurchaseAndRenewals extends Component {
  constructor(props) {
    super(props);
    this.state = {
      isLoading: true,
      isSubmitted: false,
      transactionInEdit: {},
      isPopupVisible: false,
      isEditPopupVisible: false,
      transactions: { data: [], total: 0 },
      dataState: {
        take: 10,
        skip: 0,
        filter: {
          logic: "and",
          filters: []
        },
        sort: [{ field: "TransactionId", dir: "desc" }]
      },
      modalOpen: false,
      alertVisible: false,
      alertColor: "danger",
      alertMessage: ""
    };
  }

  dataStateChange = (e) => {

    if (e.data && e.data.filter && e.data.filter.filters) {
      var filters = e.data.filter.filters;

      for (var i = 0; i < filters.length; i++) {
        if (filters[i].field && filters[i].field == "CreateDate") {
          var operator = filters[i].operator;

          if ((operator == "gt" || operator == "gte") && !filters[i].value) {

            filters[i].value = new Date('January 01, 1900');

          } else if ((operator == "lt" || operator == "lte") && !filters[i].value) {

            var currentDatetime = new Date();

            filters[i].value = new Date(Date.UTC(currentDatetime.getFullYear(), currentDatetime.getMonth(), currentDatetime.getDate()));

          }
        } else if (filters[i].field && (filters[i].field == "TransactionId" || filters[i].field == "Amount")) {
          var operator = filters[i].operator;

          if (!filters[i].value && (operator == "lt" || operator == "lte" || operator == "gt" || operator == "gte")) {

            filters[i].value = 0;

          }

        } else if (filters[i].value == null) {
          filters[i].value = "";
        }
      }
    }

    this.setState({
      ...this.state,
      dataState: e.data
    });
  }

  dataRecieved = (transactionsFetched) => {
    this.setState({
      ...this.state,
      transactions: transactionsFetched,
      isLoading: false
    });

    if (transactionsFetched.total == 0 && document.getElementsByClassName("k-grid-header-wrap").length != 0) {
      let t = document.getElementsByClassName("k-grid-header-wrap")[0].className = "horizontal-scroll";
    }
    else if (transactionsFetched.total != 0 && document.getElementsByClassName("horizontal-scroll").length != 0) {
      document.getElementsByClassName("horizontal-scroll")[0].className = "k-grid-header-wrap";
    }
  }

  edit = (dataItem) => {
    this.setState({
      transactionInEdit: Object.assign({}, dataItem),
      isPopupVisible: true
    });
  };

  editBatch = (dataItem) => {
    this.setState({
      transactionInEdit: Object.assign({}, dataItem),
      isEditPopupVisible: true
    });
  };

  cancel = () => {
    this.setState({ isPopupVisible: false })
  };

  cancelEditPopup = () => {
    this.setState({ isEditPopupVisible: false })
  };

  stringifyObj = (arr) => {
    let t = [...arr];
    if (!t) {
      return null;
    }
    else {
      for (var i = 0; i < t.length; i++) {
        var element = { ...t[i] };
        if (element["field"] == "OrderDate") {
          let date = element.value;
          if (!date) {
            date = "0001/01/01";
          }
          else {
            date = (date + '').split(" ");
            let day = date[2] + '';
            let year = date[3] + '';
            let month = "01";
            switch (date[1]) {
              case "Jan":
                month = "01";
                break;
              case "Feb":
                month = "02";
                break;
              case "Mar":
                month = "03";
                break;
              case "Apr":
                month = "04";
                break;
              case "May":
                month = "05";
                break;
              case "Jun":
                month = "06";
                break;
              case "Jul":
                month = "07";
                break;
              case "Aug":
                month = "08";
                break;
              case "Sep":
                month = "09";
                break;
              case "Oct":
                month = "10";
                break;
              case "Nov":
                month = "11";
                break;
              case "Dec":
                month = "12";
                break;
            }
            date = year + "/" + month + "/" + day;
            element["value"] = date;
          }
        }
        else {
          for (var key in t[i]) {
            element[key] = element[key] + '';
          }
        }
        t[i] = element;
      }
      return t;
    }
  }

  exportToExcel = () => {
    var Filters = this.state.dataState.filter ? this.stringifyObj([...this.state.dataState.filter.filters]) : null;
    var Sorts = this.state.dataState.sort ? this.stringifyObj([...this.state.dataState.sort]) : null;
    var KendoGridQuery = {
      Filters: Filters ? Filters.slice() : [],
      Sorts: Sorts ? Sorts.slice() : []
    }

    axios.get(ROOT_API_URL + "/ManageTransaction/ExportToExcel?queryArguments=" + JSON.stringify(KendoGridQuery), { headers: auth.authHeader() })
      .then((response) => {
        FileDownload(response.data, 'Purchases and renewals.csv');
      }).catch((error) => {
        var err = error && error.data ? error.data.message : 'Unable to export to excel.';

        this.setState({
          alertVisible: true,
          alertColor: "danger",
          alertMessage: err
        });
      });
  }

  modalToggle = () => {
    this.props.resetView()
    this.setState({
      modalOpen: !this.state.modalOpen
    });
  }

  save = (model) => {
    this.setState({
      isSubmitted: true,
      isLoading: true,
      dataState: {
        take: 10,
        skip: 0,
        filter: {
          logic: "and",
          filters: []
        },
        sort: [{ field: "TransactionId", dir: "asc" }]
      },
    });
    axios
      .post(`${ROOT_API_URL}/ManageTransaction/SaveTransaction`, model, { headers: auth.authHeader() })
      .then((response) => {
        this.setState({
          isSubmitted: false
        })
      })
      .catch((error) => {
        var err = error && error.data ? error.data.message : 'Unable to save the transaction.';

        this.setState({
          isSubmitted: false,
          alertVisible: true,
          alertColor: "danger",
          alertMessage: err
        });
      });
  }

  deleteTransaction = (model) => {
    if (model.Status != "InProgress" && model.Status != "Failed") {
      if(!model.IsBatchOpen) {
        this.setState({
          alertVisible: true,
          alertColor: "danger",
          alertMessage: 'Only in progress transactions can be deleted OR cash transactions with open batches.'
        });

        return;
      } 
    }

    this.setState({
      isSubmitted: true,
      isLoading: true,
      dataState: {
        take: 10,
        skip: 0,
        filter: {
          logic: "and",
          filters: []
        },
        sort: [{ field: "TransactionId", dir: "desc" }]
      },
    });

    if (!model.TransactionId) {
      this.setState({
        isSubmitted: false,
        isLoading: false,
        alertVisible: true,
        alertColor: "danger",
        alertMessage: "Unable to get the transaction's ID"
      });
      return;
    }

    axios
      .post(`${ROOT_API_URL}/ManageTransaction/DeleteTransaction`, model, { headers: auth.authHeader() })
      .then((response) => {
        this.setState({
          isSubmitted: false,
          isLoading: false
        })
      })
      .catch((error) => {
        var err = error && error.data ? error.data.message : 'Unable to delete the transaction.';

        this.setState({
          isSubmitted: false,
          isLoading: false,
          alertVisible: true,
          alertColor: "danger",
          alertMessage: err
        });
      });
  }

  pageChange = (event) => {
    this.setState({
      skip: event.page.skip,
      take: event.page.take
    });
  }

  refreshGird = () => {
    this.setState({
      isSubmitted: true,
      isLoading: true,
      dataState: {
        take: 10,
        skip: 0,
        filter: {
          logic: "and",
          filters: []
        },
        sort: [{ field: "TransactionId", dir: "desc" }]
      },
    });

    this.setState({
      isSubmitted: false
    })
  }


  PriceCell = (props) => <CustomCell {...props} myProp={this.customData} />

  render() {
    return (
      <div id={"transactions-grid"}>
        <AdminHeader />
        {this.state.isLoading ?
          (<div>
            <IsLoading message="Loading Purchases and renewals" />
          </div>

          ) :
          (
            <div>
              <Alert
                color={this.state.alertColor}
                isOpen={this.state.alertVisible}
                toggle={() => {
                  this.setState({ alertVisible: false, alertMessage: "" })
                }}
              >
                {this.state.alertMessage}
              </Alert>
              <Grid
                style={{ width: '80vw', height: '80vh' }}
                filterable={true}
                sortable={true}
                pageable={true}
                total={this.state.transactions.total}
                {...this.state.dataState}
                {...this.state.transactions}
                onDataStateChange={this.dataStateChange}
              >
                <GridToolbar>
                  <div className="admin-grid-toolbar-box2">
                    <button onClick={() => this.modalToggle()} className="admin-k-button">
                      <i className="fas fa-plus-circle"></i>
                      <span>ADD</span>
                    </button>
                    <button title="Export PDF" className="admin-k-button" onClick={this.exportToExcel}>
                      <i className="fas fa-file-export"></i>
                      EXPORT TO EXCEL
                    </button>
                  </div>
                </GridToolbar>
                <Column filterable={false} cell={cellWithEditing(this.edit, this.editBatch, this.deleteTransaction)} />
                <Column field="TransactionId" title="Transaction Id" filter="numeric" />
                <Column field="MembershipId" title="Membership Id" filter="text" />
                <Column field="BatchNumber" title="Batch" filter="text" />
                <Column field="CreateDate" title="Transaction Date" cell={GridDateFormatter} filter="date" />
                <Column field="Name" title="Name" filter="text" />
                <Column field="Amount" title="Total Amount" filter="numeric" format="{0:c2}" className="align-cells-right" />
                <Column field="Description" title="Payment Type" filter="text" />
                <Column field="Email" title="Email" filter="text" />
                <Column field="Status" title="Status" filter="text" />
              </Grid>
            </div>
          )
        }
        <div>
          {!this.state.isSubmitted ?
            <PurchaseAndRenewalsLoader
              dataState={this.state.dataState}
              onDataRecieved={this.dataRecieved}
            />
            : ""
          }
        </div>
        <div className="receipt">
          <Modal
            isOpen={this.state.isPopupVisible}
            onRequestClose={this.cancel}
            ariaHideApp={false}
            style={{
              content: {
                top: '50%',
                left: '50%',
                right: 'auto',
                bottom: 'auto',
                marginRight: '-50%',
                minWidth: '50vw',
                maxWidth: '50vw',
                minHeight: '80vh',
                maxHeight: '80vh',
                overflow: 'auto',
                transform: 'translate(-50%, -50%)',
                borderRadius: '5px'
              }
            }}
          >
            <ReceiptPDF
              pdfData={this.state.transactionInEdit.TransactionId}
              cancel={this.cancel}
            />
          </Modal>
          <Modal
            isOpen={this.state.isEditPopupVisible}
            onRequestClose={this.cancelEditPopup}
            ariaHideApp={false}
            style={{
              content: {
                top: '50%',
                left: '50%',
                right: 'auto',
                bottom: 'auto',
                marginRight: '-50%',
                minWidth: '80vw',
                maxWidth: '80vw',
                minHeight: '80vh',
                maxHeight: '80vh',
                overflow: 'auto',
                transform: 'translate(-50%, -50%)',
                borderRadius: '5px'
              }
            }}
          >
            <DialogContainer
              dialogType="edit"
              transactionData={this.state.transactionInEdit}
              refreshGird={this.refreshGird}
              cancel={this.cancelEditPopup}
            />

          </Modal>
        </div>
        <div>
          <Modal
            isOpen={this.state.modalOpen}
            onRequestClose={this.modalToggle}
            contentLabel="Example Modal"
            ariaHideApp={false}
            style={{
              content: {
                top: '50%',
                left: '50%',
                right: 'auto',
                bottom: 'auto',
                marginRight: '-50%',
                minWidth: '80vw',
                maxWidth: '80vw',
                minHeight: '80vh',
                maxHeight: '80vh',
                overflow: 'auto',
                transform: 'translate(-50%, -50%)',
                borderRadius: '5px'
              }
            }}
          >
            <PurchaseContainer modalToggle={this.modalToggle} refreshGrid={this.refreshGird} />
          </Modal>
        </div>
      </div>

    );
  }
}

function mapStateToProps(state) {
  return {
    common: state.common
  };
}

export default connect(mapStateToProps, {
  resetView
})(ManagePurchaseAndRenewals);
